/**
 * Plugin responsible for adding the .using-mouse class to the body component on
 * mousedown events and removing it when the Tab key is used
 */
const Plugin = {
  install (): void {
    // Let the document know when the mouse is being used
    document.body.addEventListener('mousedown', function () {
      document.body.classList.add('using-mouse')
    }, true)

    // Remove the using-mouse class when the user presses the Tab key
    document.body.addEventListener('keydown', function (event) {
      if (event.key === 'Tab') {
        document.body.classList.remove('using-mouse')
      }
    }, true)
  }
}

export default Plugin
